"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacing = void 0;
const foundation_1 = require("../foundation");
exports.spacing = {
    ids_spacing_1x: foundation_1.foundation_size.tiny.size_tiny_4,
    ids_spacing_2x: foundation_1.foundation_size.tiny.size_tiny_8,
    ids_spacing_3x: foundation_1.foundation_size.small.size_small_12,
    ids_spacing_4x: foundation_1.foundation_size.small.size_small_16,
    ids_spacing_5x: foundation_1.foundation_size.small.size_small_20,
    ids_spacing_6x: foundation_1.foundation_size.small.size_small_24,
    ids_spacing_8x: foundation_1.foundation_size.medium.size_medium_32,
    ids_spacing_10x: foundation_1.foundation_size.medium.size_medium_40,
    ids_spacing_12x: foundation_1.foundation_size.medium.size_medium_48,
    ids_spacing_14x: foundation_1.foundation_size.medium.size_medium_56,
};
//# sourceMappingURL=spacing.js.map